import { normalizePhoneInput, PHONE_MAX_DIGITS } from '../../lib/phone';

export interface ContactFormValue {
  name: string;
  phone: string;
  department?: string;
  position?: string;
  email?: string;
}

export type ContactFormErrors = Partial<Record<keyof ContactFormValue, string>>;

interface ContactFormFieldsProps {
  value: ContactFormValue;
  onChange: (next: ContactFormValue) => void;
  errors?: ContactFormErrors;
  disabled?: boolean;
  className?: string;
}

export function ContactFormFields({
  value,
  onChange,
  errors,
  disabled,
  className,
}: ContactFormFieldsProps) {
  const update = <K extends keyof ContactFormValue>(key: K, next: ContactFormValue[K]) => {
    onChange({ ...value, [key]: next });
  };

  const inputClass =
    'w-full px-3 py-2 border border-ink-300 rounded-control text-sm focus:ring-brand-500 focus:border-brand-500 disabled:bg-surface-soft disabled:text-ink-500';

  return (
    <div className={className ?? 'space-y-3'}>
      <div>
        <label className="block text-sm font-medium text-ink-700 mb-1">담당부서</label>
        <input
          type="text"
          placeholder="예: 안전관리팀"
          value={value.department ?? ''}
          onChange={(e) => update('department', e.target.value)}
          disabled={disabled}
          className={inputClass}
        />
        {errors?.department && (
          <p className="mt-1 text-xs text-red-600">{errors.department}</p>
        )}
      </div>
      <div>
        <label className="block text-sm font-medium text-ink-700 mb-1">
          성명 <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          placeholder="이름"
          value={value.name}
          onChange={(e) => update('name', e.target.value)}
          disabled={disabled}
          className={inputClass}
        />
        {errors?.name && <p className="mt-1 text-xs text-red-600">{errors.name}</p>}
      </div>
      <div>
        <label className="block text-sm font-medium text-ink-700 mb-1">직책</label>
        <input
          type="text"
          placeholder="예: 현장소장"
          value={value.position ?? ''}
          onChange={(e) => update('position', e.target.value)}
          disabled={disabled}
          className={inputClass}
        />
        {errors?.position && (
          <p className="mt-1 text-xs text-red-600">{errors.position}</p>
        )}
      </div>
      <div>
        <label className="block text-sm font-medium text-ink-700 mb-1">
          연락처 <span className="text-red-500">*</span>
        </label>
        {/* 숫자만 — 서버 계약이 숫자만이라 보이는 값도 그렇게 유지한다(lib/phone).
            전송 때만 바꾸면 화면과 실제 값이 어긋나 "입력은 됐는데 저장이 안 된다"가 된다. */}
        <input
          type="tel"
          inputMode="numeric"
          maxLength={PHONE_MAX_DIGITS}
          placeholder="01012345678"
          value={value.phone}
          onChange={(e) => update('phone', normalizePhoneInput(e.target.value))}
          disabled={disabled}
          className={inputClass}
        />
        {errors?.phone && <p className="mt-1 text-xs text-red-600">{errors.phone}</p>}
      </div>
      <div>
        <label className="block text-sm font-medium text-ink-700 mb-1">이메일</label>
        <input
          type="email"
          placeholder="email@example.com"
          value={value.email ?? ''}
          onChange={(e) => update('email', e.target.value)}
          disabled={disabled}
          className={inputClass}
        />
        {errors?.email && <p className="mt-1 text-xs text-red-600">{errors.email}</p>}
      </div>
    </div>
  );
}
